<vtabela id="expurgos" grid-options="ctrl.vtabela" analytics-category="Relatorios" analytics-label="expurgos"></vtabela>